import { compose } from 'redux';
import { connect } from 'react-redux';
import { PERMISSION, SMARTSPOT_MODE, SMARTSPOT_REASON } from 'constants/logic';
import { userHasPermission } from 'helpers/core';
import {
  selectUserInfo,
  selectVenueSmartspotData,
  selectActiveVenue,
  selectVenueSmartspotCanTurnOnOff,
} from 'selectors/general';
import { updateSmartSpot as updateSmartSpotAction } from 'components/SmartSpot';
import ManageSmartSpotModal from './ManageSmartSpotModal';

function mapStateToProps(state, ownProps) {
  const { schedule = {} } = ownProps;
  let { venue } = ownProps;
  if (!venue) {
    venue = selectActiveVenue(state, ownProps);
  }

  const { mode: venueSmartspotMode } = selectVenueSmartspotData(state, ownProps);
  const { smartspotEnabled: scheduleSmartspotEnabled, smartspotMode: scheduleSmartspotMode } = schedule;
  const user = selectUserInfo(state, ownProps);

  return {
    venue,
    schedule,
    canManageSmartspotOnOff: selectVenueSmartspotCanTurnOnOff(state),
    canManageSmartspotVersion: userHasPermission(user, PERMISSION.CAN_MANAGE_SMARTSPOT_VERSION),
    initialValues: {
      smartspotEnabled: scheduleSmartspotEnabled,
      mode: scheduleSmartspotMode || venueSmartspotMode || SMARTSPOT_MODE.AGGRESSIVE,
      reason: SMARTSPOT_REASON.SCHEDULE_SETTING,
    },
  };
}

const mapDispatchToProps = {
  updateSmartSpot: updateSmartSpotAction,
};

function mergeProps(stateProps, dispatchProps) {
  const { venue, schedule = {} } = stateProps;
  const { updateSmartSpot } = dispatchProps;
  const { venueId } = venue;
  const {
    scheduleClass,
    scheduleId,
    scheduleName: className,
    startDateTime,
    smartspotEnabled: smartspotEnabledForClass,
    canOnlyToggleNonRecurring,
  } = schedule;
  const { classId } = scheduleClass || {};

  return {
    ...stateProps,
    smartspotEnabledForClass,
    canOnlyToggleNonRecurring,
    onSubmit: ({ smartspotEnabled, reason }) => {
      const data = {
        isEnabled: smartspotEnabled,
      };
      const meta = {
        classId,
        className,
        isModal: true,
        reason: canOnlyToggleNonRecurring ? SMARTSPOT_REASON.SCHEDULE_SETTING : reason,
        scheduleId,
        startDateTime,
        venueId,
      };

      updateSmartSpot(data, meta);
    },
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps, mergeProps))(ManageSmartSpotModal);
